import css from './graph.module.scss';

import { memo, CSSProperties, useState } from 'react';

import { TTimeRecord } from '../types';
import Curve from './Curve';
import Frame from './Frame';
import Grid from './Grid';
import Legend from './Legend';
import Points from './Points';
import cfg from './gridConstans';
import useCoordinates from './hooks/useCoordinates';
import useData from './hooks/useData';
import useSteps from './hooks/useSteps';

type TProps = {
  data: TTimeRecord[];
};

const WeeksGraph = ({ data }: TProps) => {
  const [domNode, setDomNode] = useState<HTMLDivElement | null>(null);

  // 1px = ? points inside <svg/>
  const px = cfg.SVG.WIDTH / (domNode?.offsetWidth || cfg.SVG.WIDTH);
  const style = { ['--px']: px };

  const { dataSorted, maxCount, maxWeeks } = useData(data);
  const { x, y, xy, graphRect, svgHeight } = useCoordinates(
    domNode,
    px,
    maxWeeks,
    maxCount
  );
  const steps = useSteps(maxWeeks, maxCount);

  return (
    <div className={css.svgWrapper} ref={setDomNode}>
      {domNode && (
        <svg
          viewBox={`0 0 ${cfg.SVG.WIDTH} ${svgHeight}`}
          style={style as CSSProperties}
        >
          <Frame graphRect={graphRect} mode="background" />
          <Grid
            x={x}
            y={y}
            steps={steps}
            graphRect={graphRect}
            maxCount={maxCount}
            maxWeeks={maxWeeks}
          />
          <Legend
            x={x}
            y={y}
            steps={steps}
            graphRect={graphRect}
            px={px}
            maxCount={maxCount}
            maxWeeks={maxWeeks}
          />
          <Frame graphRect={graphRect} mode="border" />
          <Curve dataSorted={dataSorted} xy={xy} />
          <Points dataSorted={dataSorted} x={x} y={y} />
        </svg>
      )}
    </div>
  );
};

export default memo(WeeksGraph);
